import readableBytes from './readableBytes';

export default {
  // Create a disk usage bytes text.
  bytesText(disk) {
    return disk
      ? `${readableBytes(disk.usedBytes)} / ${readableBytes(disk.totalBytes)}`
      : undefined;
  },

  // Create a disk percent text.
  percentText(disk) {
    return disk
      ? `${((disk.usedBytes / disk.totalBytes) * 100).toFixed(1)}%`
      : undefined;
  },

  // Create a disk usage array
  percentArray(disk) {
    return [((disk.usedBytes / disk.totalBytes) * 100).toFixed(1)];
  },
};
